import { useQuery } from '@tanstack/react-query'
import { TChartLabel, TDevice } from 'shared/types'
import { api, getDevice } from '..'

export const getChartLabel = async (
  chartLabelId: string,
): Promise<TChartLabel & { device: TDevice }> => {
  const data = await api
    .get<TChartLabel>(`/v1/charts/labels/${chartLabelId}`)
    .then(({ data }) => data)
  const device = await getDevice(data.deviceId)

  return { ...data, device }
}

export const getChartLabelQuery = (chartLabelId: string) => ({
  queryFn: () => getChartLabel(chartLabelId),
  queryKey: ['chartLabel', chartLabelId],
})

export const useGetChartLabel = (chartLabelId?: string) => {
  if (!chartLabelId) throw new Error('Missing chartLabelId')
  const query = getChartLabelQuery(chartLabelId)

  return useQuery(query)
}
